import React, { Component } from "react";
import { Modal, Form, Input, Row, Col, Select, Radio } from "antd";
import { createRoute, updateRoute } from "../../services/route";

const { Option } = Select;

class RouteFormModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            disableOkButton: false
        }
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.prepareForm = this.prepareForm.bind(this);
        this.formRef = React.createRef();
    }

    async onFormSubmit() {
        const { data, editing, setVisible, reloadData, reloadAfterCreate } = this.props;
        await this.setState({
            disableOkButton: true
        })
        let values;
        let passed = true;
        try {
            values = await this.formRef.current.validateFields()
        }
        catch (err) {
            values = err.values
            passed = false
        }
        if (passed) {
            if (!editing) {
                await createRoute(values)
                reloadAfterCreate();
            }
            else {
                await updateRoute(data['id'], values)
                reloadData();
            }
            setVisible(false);
        }
        this.setState({
            disableOkButton: false
        })

    };

    componentDidMount() {
        this.props.onRef(this);
    }

    async prepareForm() {

    }

    render() {
        const { editing, visible, setVisible, data } = this.props;
        const { disableOkButton } = this.state;
        const truckTypeOptions = [
            { name: "4 ล้อ", value: "FOUR_WHEEL" },
            { name: "6 ล้อ", value: "SIX_WHEEL" }
        ]
        return (
            <Modal
                visible={visible}
                onCancel={() => { setVisible(false) }}
                onOk={this.onFormSubmit}
                title={editing ? "แก้ไขรายการ" : "เพิ่มรายการ"}
                okText={editing ? "แก้ไข" : "เพิ่ม"}
                cancelText={"ปิด"}
                keyboard={false}
                maskClosable={false}
                destroyOnClose={true}
                okButtonProps={{ disabled: disableOkButton }}
            >
                <Form
                    ref={this.formRef}
                    layout={'vertical'}
                    initialValues={data}
                >
                    <Row gutter={12}>
                        <Col span={24}>
                            <Form.Item
                                hasFeedback
                                label="ชื่อสาย"
                                name="name"
                                rules={[
                                    {
                                        required: true,
                                        message: "กรุณาใส่ชื่อสาย"
                                    }
                                ]}>
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={12}>
                        <Col span={24}>
                            <Form.Item
                                hasFeedback
                                label="รายละเอียด"
                                name="description"
                                rules={[]}>
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={12}>
                        <Col span={24}>
                            <Form.Item
                                hasFeedback
                                label="พนักงานขับ"
                                name="driver"
                                rules={[{ required: true, message: 'กรุณาใส่ชื่อพนักงานขับ' }]}>
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={12}>
                        <Col span={24}>
                            <Form.Item
                                hasFeedback
                                label="ทะเบียรถ"
                                name="truck_license"
                                rules={[{ required: true, message: 'กรุณาใส่ชื่อทะเบียนรถ' }]}>
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item
                            label="ประเภทรถ"
                            name="truck_type"
                            rules={[
                                {
                                    required: true,
                                    message: "กรุณาเลือกประเภทรถ"
                                }
                            ]}
                        >
                            <Radio.Group>
                                {truckTypeOptions.map(tto => <Radio key={tto.value} value={tto.value}>{tto.name}</Radio>)}
                            </Radio.Group>
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}

export default RouteFormModal;